<template>
    <div class="readly-pload-order">
        <div class="item-view" @mouseenter="handleEnter" @mouseleave="handleLeave">
            <img class="item-view-img" :src="show_img" v-on:load="imageLoaded" v-on:error="imageFailed"/>
            <i class="el-icon-error" @click="handleDel"></i>
        </div>
        <h5 class="item-title mi-work-order-title ellipsis">
            {{ params.material_name }}
        </h5>
    </div>
</template>

<script>
    import noImg from '@/assets/img/mi-no-img.png'
    export default {
        name: 'readly-pload-order',
        props:{
            params: {
                type: Object,
                default: function() {
                    return {
                        material_name: '',
                        type: 1, //这里使用type  值与material_type相同
                        full_material_url:'',
                        material_url:'',
                        img_material_url: '',
                        img_full_material_url: '',
                        material_size:'',
                        material_duration: ''
                    }
                }
            }
        },
        data() {
            return {
                clearId: '',
                no_img: noImg,
                show_img: '',
                is_fail: false  // 图片是否开裂
            }
        },
        // created() {
        //     console.log('this.params.img_full_material_url', this.params.img_full_material_url)
        //     this.show_img = this.params.img_full_material_url
        // },
        watch:{
            'params':{
                handler() {
                    this.show_img = this.params.img_full_material_url ? this.params.img_full_material_url : ''
                },
                deep: true,
                immediate:true
            }
        },
        methods:{
            handleEnter(e) {
                this.$emit('preview', e.target, 'leave')
                clearTimeout(this.clearId)

                if(this.is_fail && this.params.type != 3) {
                    this.$message.warning('图片加载失败、无法预览')
                    return
                }

                this.clearId = setTimeout(() => {
                    this.$emit('preview', e.target, 'enter')
                }, 1000);
                    
            },
            handleLeave(e) {
                clearTimeout(this.clearId)
                // this.$emit('preview', e.target, 'leave')
            },
            handleDel() {
                clearTimeout(this.clearId)
                this.$emit('preview', '', 'leave')
                this.$emit('del')
            },
            imageLoaded() {
            },
            imageFailed() {
                this.is_fail = true
                this.show_img = this.no_img
            }
        }
    }
</script>

<style lang="scss" scoped>
.readly-pload-order {
    min-width: 100px;
    max-width: 180px;

    .item-title {
        padding: 0;
        border: none;
        font-weight: normal;
        max-width: 160px;
        font-size: 12px;
    }

    .item-view {
        position: relative;
        margin-bottom: 8px;
        margin-top: 8px;
        width: 130px;
        height: 80px;
        cursor: pointer;

        .item-view-img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            border: 1px solid #DCDFE6;
        }

        .item-view-video {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center;
            border: 1px solid #DCDFE6;
        }

        .mask {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
        }

        .el-icon-error {
            display: none;
            font-size: 24px;
            color: red;
            position: absolute;
            top: -8px;
            right: -8px;
            z-index: 99;
            background-color: #fff;
            border-radius: 50%;
        }

        &:hover {
            .mask {
                display: block;
            }

            .el-icon-error {
                display: block;
            }
        }
    }

}
</style>